import { useRef, useState } from "react";
import { Input } from "components/ui/input";
import clsx from "clsx";

type InputSuggestionProps = {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  disabled?: boolean;
  className?: string;
  suggestions: string[];
  maxLength?: number;
};

export default function InputSuggestion({ value, onChange, placeholder = "", disabled = false, className = "", suggestions, maxLength }: InputSuggestionProps) {
  const [open, setOpen] = useState(false);
  const timeoutRef = useRef<any>(null);

  const filtered = suggestions.filter((s) => s.toLowerCase().includes(value.toLowerCase())).filter((s) => (maxLength ? s.length <= maxLength : true));

  const handleSelect = (val: string) => {
    onChange(val);
    setOpen(false);
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value;
    if (maxLength !== undefined && inputValue.length > maxLength) return;
    onChange(inputValue);
    setOpen(true);
  };

  const isLimitReached = maxLength !== undefined && value.length >= maxLength;

  return (
    <div className={`relative w-full max-w-sm ${className}`}>
      <Input
        value={value}
        onChange={handleInputChange}
        onFocus={() => {
          clearTimeout(timeoutRef.current);
          setOpen(true);
        }}
        onBlur={() => {
          timeoutRef.current = setTimeout(() => setOpen(false), 100);
        }}
        placeholder={placeholder}
        disabled={disabled}
        className={clsx({ "border-destructive text-destructive": isLimitReached })}
      />

      {/* Suggestion Box */}
      {open && value && filtered.length > 0 && (
        <div className="absolute z-10 w-full mt-1 bg-popover border border-border rounded-md shadow-sm">
          {filtered.map((item, index) => (
            <div key={index} onClick={() => handleSelect(item)} className="px-3 py-2 cursor-pointer hover:bg-muted transition-all">
              {item}
            </div>
          ))}
        </div>
      )}

      {/* Character Counter */}
      {maxLength !== undefined && (
        <div className={clsx("text-right text-xs mt-1", isLimitReached ? "text-destructive" : "text-muted-foreground")}>
          {value.length}/{maxLength}
        </div>
      )}
    </div>
  );
}

